import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
  providedIn: 'root'
})
export class SubjectService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService) {
    super(http, alertService, globalService);
  }

  create(data): Observable<any> {
    return this.postRequest(AppUrl.SUBJECTS(), data);
  }

  detail(id): Observable<any> {
    return this.getRequest(AppUrl.SUBJECTS(id));
  }

  get(data): Observable<any> {
    return this.getRequest(AppUrl.SUBJECTS(), data);
  }

  update(id, data): Observable<any> {
    return this.putRequest(AppUrl.SUBJECTS(id), data);
  }

  updateStatus(id, data): Observable<any> {
    return this.putRequest(AppUrl.SUBJECT_STATUS(id), data);
  }
}
